<template>
  <div class="page organisation">
    <div class="content title">
      {{ $t('organization.createOrganization.title') }}
    </div>

    <div class="content section">
      <div class="col">
        <div class="title">{{ $t('organization.name') }}</div>

        <input
          id="name"
          v-model="name"
          :class="{ invalid: isSend && (name.length >= 30 || !name.length) }"
          class="text-input opacity"
          name="name"
          type="text"
        />

        <div v-if="isSend && name.length >= 30" class="error">
          {{ $t('organization.maxCharacters', { max: 30 }) }}
        </div>
        <div v-if="isSend && !name.length" class="error">
          {{ $t('organization.errorMessage') }}
        </div>
      </div>

      <div class="col">
        <div class="title">{{ $t('organization.userEmail') }}</div>

        <input
          id="email"
          v-model="email"
          :class="{ invalid: isSend && !email.length }"
          class="text-input opacity"
          name="email"
          type="email"
        />

        <div v-if="isSend && !email.length" class="error">
          {{ $t('organization.errorMessageEmail') }}
        </div>
      </div>
    </div>

    <div class="content submit">
      <div class="main-button button-cancel" @click="$router.push({ name: 'home' })">
        <div class="text">{{ $t('organization.cancelButton') }}</div>
      </div>

      <div class="main-button button-create" @click="createOrganization">
        <div class="text">
          {{ $t('organization.createOrganization.createButton') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreateOrganisation',

  data() {
    return {
      isSend: false,
      name: '',
      email: '',
    };
  },

  methods: {
    async createOrganization() {
      this.isSend = true;

      try {
        await this.$store.dispatch('organization.create', {
          name: this.name,
          email: this.email,
        });

        this.$store.dispatch('toaster/organizationCreated');
        this.$router.push({ name: 'home' });
      } catch (e) {
        console.error(e);
        this.$store.dispatch('toaster/organizationCreationFailed');
      }
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';

.organisation {
  padding: 96px 0 0;

  .content {
    width: 60%;
    padding: 16px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;

    &.title {
      color: colors.$light-blue-color;
      font-size: 36px;
      font-weight: bold;
      letter-spacing: 1px;
    }

    &.section {
      border-radius: 7px;
      background-color: colors.$white-color;
      box-shadow: 0 1px 7px 0 rgba(167, 167, 167, 0.5);
      padding: 38px 48px;
      box-sizing: border-box;

      .col {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-direction: column;
        height: 100%;

        .title {
          color: #939292;
          font-size: 16px;
          margin-bottom: 6px;
        }

        .error {
          margin-top: 12px;
          font-size: 16px;
          color: colors.$red-color;
        }

        input {
          width: 280px;

          &.invalid {
            border-color: colors.$red-color;
          }
        }

        &:nth-child(2n) {
          margin-left: 38px;
        }
      }
    }

    &.submit {
      justify-content: flex-end;

      .main-button {
        margin: 28px 0 0;
      }

      .button-create {
        margin-left: 16px;
      }
    }
  }
}
</style>
